__turbopack_context__.v({
  "carousel-skeleton": "carousel-skeleton-module-scss-module__GStK2a__carousel-skeleton",
  "carousel-skeleton__card-row": "carousel-skeleton-module-scss-module__GStK2a__carousel-skeleton__card-row",
  "carousel-skeleton__title-skeleton": "carousel-skeleton-module-scss-module__GStK2a__carousel-skeleton__title-skeleton",
  "carousel-skeleton__title-skeleton-wrapper": "carousel-skeleton-module-scss-module__GStK2a__carousel-skeleton__title-skeleton-wrapper",
});
